import React from 'react';
import CountriesContext from '../CountriesContext/index';
import { NewCountriesContextProps } from '../_type';

const DauCountriesContext = (props: NewCountriesContextProps) => {
  const { filterVal, filterLoading, state } = props || {}
  const { regionDataType } = state || {};

  return (
    <>
      <CountriesContext
        filterLoading={filterLoading}
        regionDataType={regionDataType}
        filterVal={filterVal}
        metric='dau'
      />
    </>
  );
};

export default DauCountriesContext;
